import React, { useEffect } from "react";
import { connect } from "react-redux";
import HeaderComponent from "components/card/HeaderComponent";
import PreviousWinnersCard from "./PreviousWinnersCard";
import { Pagination } from "antd";
import {
  getPreviousMonthList
} from "../../../../redux/corevalueswinner/corevalueswinnerState";

const PreviousWinner = ({
  getPreviousMonthList,
  pagination,
  recordList,
}) => {

  useEffect(() => {
    getPreviousMonthList();
  }, []);

  return (
    <HeaderComponent
      title="Previous Winners"
      description="Recent value champions from past months"
      descriptionClass="text-sm muted-text"
    >
      <div>
        {recordList?.length > 0 ? (
          <PreviousWinnersCard recordList={recordList} />
        ) : (
          <div className="text-center py-10 text-gray-500">
            No previous winners found.
          </div>
        )}
      </div>
      <div className="flex justify-end py-4">
        <Pagination
          current={pagination?.current_page || 1}
          pageSize={pagination?.per_page || 10}
          total={pagination?.total || 0}
          showSizeChanger={false}
          onChange={(page) => {
            getPreviousMonthList({
              page,
              paginate: pagination?.per_page || 10,
            });
          }}
        />
      </div>
   </HeaderComponent>
  );
};

const mapStateToProps = (state) => ({
  recordList: state.coreValuesWinner.previousMonth?.items,
  pagination: state.coreValuesWinner.previousMonth?.pagination,
  filters: state.coreValuesWinner.previousMonth?.filters,
  requesting: state.coreValuesWinner.previousMonth?.requesting,
  error: state.coreValuesWinner.previousMonth?.error,
});

const mapDispatchToProps = (dispatch) => ({
  getPreviousMonthList: (data) => dispatch(getPreviousMonthList(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PreviousWinner);
